export const getFullName = (firstName?: string, lastName?: string) =>
  `${firstName || ''} ${lastName || ''}`.trim()
